import React from "react";
import TopNav from "../Navbar/TopNav";
import NewMainNav from "../Navbar/NewMainNav";

const Navbar = () => {
  return (
    <React.Fragment>
      <TopNav />
      <NewMainNav />
    </React.Fragment>
  );
};

export default Navbar;
